import cn from 'classnames';
import { Grid, Icon } from 'ht-styleguide';

import styles from '@scenes/LoginPage/LoginForm/loginform.module.scss';

type CustomHeaderProps = {
  handleClose: BaseAnyFunction;
  showCloseIcon: boolean;
  showLogo: boolean;
};

export const CustomHeader = ({ handleClose, showCloseIcon, showLogo }: CustomHeaderProps) => {
  const iconContainerStyles = cn('flex justifyContentSpaceBetween marginTop-small2', styles.iconContainer);

  return (
    <header>
      <Grid.FullWidth classes="marginAuto">
        <Grid.Row classes={styles.modalHeader}>
          <Grid.Column lg={2} lgOffset={2}>
            {showLogo && (
              <div className={styles.header}>
                <div className={`flex alignItemsCenter justifyContentCenter ${styles.logoOuterWrapper}`}>
                  <Icon name="logo" className={styles.logo} />
                </div>
              </div>
            )}
          </Grid.Column>
          <Grid.Column lg={1} lgOffset={2}>
            {showCloseIcon && (
              <div className={iconContainerStyles}>
                <Icon name="close" className="n700" onClick={handleClose} />
              </div>
            )}
          </Grid.Column>
        </Grid.Row>
      </Grid.FullWidth>
    </header>
  );
};
